export default {
  name: 'ConfirmModal',
  props: {
    cancelText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '确认'
    },
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: '删除后内容将无法恢复确认删除吗？'
    },
    strongButton: {
      type: String,
      default: 'confirm'
    }
  },
  methods: {
    onCancel() {
      this.$emit('onCancel');
    },
    onConfirm() {
      this.$emit('onConfirm');
    }
  }
};